module.exports = __webpack_public_path__ + "static/media/combattant.2a7348c9.jpg";